import React, { FC, useState } from 'react'
import moment from 'moment'
import { PhotographIcon } from '@heroicons/react/solid'
import ROUTES from '../utils/routes'
import RenderSlate from '../Slate/RenderSlate'
import { linkToSizedImage } from '../IssueEntityImage/helpers'
import { SearchIssues_searchIssue_docs } from '../../graphql/Issue/__generated__/SearchIssues'
import { StyledIssueListItem, IssueListImage } from '.'

type Props = {
  issue: SearchIssues_searchIssue_docs;
}

const IssueListItem: FC<Props> = ({ issue }) => {
  return (
    <>
      <StyledIssueListItem to={ROUTES.issues.viewBySlug(issue.slug)}>
        <div className="issue-image">
          {issue.headerImg && (
            <IssueListImage
              src={linkToSizedImage(issue.headerImg.fileHttpLink, { width: 700 })}
              alt={issue.title}
            />
          )}
          {!issue.headerImg && <PhotographIcon className="empty-icon" />}
        </div>
        <div className="issue-details">
          <span className="issue-title">{issue.title}</span>
          <span className="issue-description-preview">
            <RenderSlate html={issue.about} plainText />
          </span>
        </div>
      </StyledIssueListItem>
    </>
  )
}

export default IssueListItem
